export const villaUrls = {
  SERVICES_PRE_DESIGN_VILLAS: '/dashboard/services/select-villa/',
};
